// extracted by mini-css-extract-plugin
module.exports = {"error-container":"_35875ce240--error-container--yX0D5","mobile":"_35875ce240--mobile--YTIbm"};